import createModel from '../lib/create_model';

const FollowedTaskReplied = createModel({
  modelName: 'FollowedTaskReplied',

  properties: {
    itemId: String,
    customerId: String,
    taskId: String,
  },
});

export default FollowedTaskReplied;
